<template>
  <el-button type="primary" v-on:click="AddUser"  round>账号授权</el-button>

</template>

<script>
export default {
  data() {
    return {
      handleClose:false,
      dialog:false,
      values:"",
      options:[],
      list:[],
      loading:false,
      indexro:"https://open-ad.vivo.com.cn/OAuth?clientId=20220715001&state=gettoken&redirectUri=https://test.nbweiou.cn/get_token",
      formLabelWidth: '60px',
      form:{
        apiId:'',
        apiKey:'',
        name:'',
        advertiseid:''
      }
    }
  },
  methods: {
    /**
     * 授权账号
     * @constructor
     */

    AddUser(){
        window.open(this.indexro,'_blank') // 在新窗口打开外链接
      // window.location.href = 'https://open-ad.vivo.com.cn/OAuth?clientId=20220715001&state=gettoken&redirectUri=https://test.nbweiou.cn/get_token';
    }
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/login/ScheduledSendToV.vue